import React, {ElementType} from 'react';
import {Box, Typography} from "@mui/material";
import PremiumBadge from "./premiumBadge";
import {Theme} from "@mui/material/styles";

export type PremiumFeature = {
    icon: ElementType,
    label: string
}

type PremiumFeaturesBoxProps = {
    title: string,
    features: PremiumFeature[]
}

export default function PremiumFeaturesBox({title, features}: PremiumFeaturesBoxProps): JSX.Element {
  return (
    <Box sx={{width: "100%", boxSizing: "border-box", backgroundColor: "premium.x_light", border: 1, borderColor: "premium.main", borderRadius: 2, p: 4, mb: 6}}>
      <Box sx={{display: "flex", justifyContent: "space-between", mb: 3}}>
        <Typography variant="h1" color="neutral.dark" sx={{fontWeight: "bold"}}>
          {title}
        </Typography>
        <PremiumBadge />
      </Box>
      <Box sx={{display: "flex", gap: 3}}>
        {features.map(({icon: Icon, label}) => (
          <Box key={label} sx={{display: "flex", alignItems: "center", gap: 2, minWidth: 0}}>
            <Box sx={{
              width: 33, height: 33, borderRadius: "50%", boxSizing: "border-box",
              backgroundColor: "common.white", border: "1px solid", borderColor: "grey.300",
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
            }}>
              <Box sx={{ 
                width: 31, height: 31, borderRadius: "50%", boxSizing: "border-box",
                backgroundColor: "premium.main", border: "1px solid", borderColor: "common.white",
                boxShadow: (theme: Theme): string => `0 0 0 1px ${theme.palette.grey[300]}`,
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
              }}>
                <Icon sx={{width: 15, height: 15, color: "neutral.dark"}} />
              </Box>
            </Box>
            <Typography variant="body2" color="neutral.dark" sx={{minWidth: 0, whiteSpace: "pre-line"}}>
              {label}
            </Typography>
          </Box>

        ))}
      </Box>
    </Box>
  );
}